import { RouteRecordRaw } from 'vue-router'
import loginRoutes from './routes/login.routes'
import registerRoutes from './routes/register.routes'
import alliancesRegisterRoutes from './routes/alliances-register.routes'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { name: 'login' },
  },
  ...loginRoutes,
  {
    path: '/user/login/:pathMatch(.*)*',
    name: 'login-with-any',
    redirect: { name: 'login' },
  },
  ...registerRoutes,
  ...alliancesRegisterRoutes,
  {
    path: '/user/register/:pathMatch(.*)*',
    name: 'register-with-any',
    redirect: { name: 'register' },
  },
  {
    path: '/user/remember-password',
    name: 'request-password',
    component: () => import('@/micro/views/recover-password/RequestPasswordView.vue'),
  },
  {
    path: '/user/password-reset/key/:key',
    name: 'change-password',
    component: () => import('@/micro/views/recover-password/ChangePasswordView.vue'),
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: () => import('@/micro/views/not-found/NotFoundView.vue'),
  },
]

export default routes
